import Button from 'components/Button';
import DjangoMessages from 'components/DjangoMessages';
import FormResult from 'components/Form/FormResult';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import TablePagination from 'components/Table/TableComponents/TablePagination';
import Table from 'components/Table/TableStatic';
import ExportHistoryDataModal, {
    useExportHistoryDataModal,
} from 'pages/History/components/ExportModal';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import updateUrlParamsAndReload from 'utils/pagination';

import Filter from './components/filter';
import NoResults from './components/no-results';
import ClearFilteredResultsInformationDialog from './components/results-for';
import Row from './components/row';
import {FilterFormData, SendingOrdersBackendData} from './types';

const SendingOrdersList = () => {
    const modalProps = useExportHistoryDataModal('sending-order');

    const {
        appPermissions,
        data: {
            defaultFilteredValues,
            filteredClient,
            filteredDocument,
            pagination,
            sendingOrders,
        },
    } = useBackend<SendingOrdersBackendData>();

    const methods = useForm<FilterFormData>({
        defaultValues: {
            search: defaultFilteredValues.search,
        },
    });

    const isFiltered = !!defaultFilteredValues.search;

    return (
        <FormProvider {...methods}>
            <FormResult />
            <div className="flex flex-col gap-2">
                <DjangoMessages />
                <NavigationTabs.History
                    permissions={appPermissions}
                    selection="sendingOrders"
                />
                <Filter isFiltered={isFiltered} />
                {filteredClient && (
                    <ClearFilteredResultsInformationDialog
                        label={t`Showing only send orders to ${filteredClient}.`}
                    />
                )}
                {filteredDocument && (
                    <ClearFilteredResultsInformationDialog
                        label={t`Showing only send orders for ${filteredDocument}.`}
                    />
                )}
                {sendingOrders.length === 0 && (
                    <NoResults isFiltered={isFiltered} />
                )}
                {sendingOrders.length > 0 && (
                    <>
                        <Table classNameTable="table-fixed" hasStripes={true}>
                            <Table.Header className="text-nowrap">
                                <Table.Column className="w-80">{t`Order Date`}</Table.Column>
                                <Table.Column>{t`Sender`}</Table.Column>
                                <Table.Column>{t`Client`}</Table.Column>
                                <Table.Column className="float-right">
                                    <Button
                                        kind="secondary"
                                        onClick={() =>
                                            modalProps.setIsModalOpen(true)
                                        }
                                        size="xs"
                                    >{t`Export`}</Button>
                                </Table.Column>
                            </Table.Header>
                            <Table.Body>
                                {sendingOrders.map((sendingOrder) => (
                                    <Row
                                        key={sendingOrder.mid}
                                        {...sendingOrder}
                                    />
                                ))}
                            </Table.Body>
                        </Table>
                        <TablePagination
                            className="mb-5"
                            hideForSinglePage={true}
                            isAmbigousStop={true}
                            onChange={(page) =>
                                updateUrlParamsAndReload('page', page)
                            }
                            onFirst={() => updateUrlParamsAndReload('page', 1)}
                            onLast={() =>
                                updateUrlParamsAndReload('page', 'last')
                            }
                            pageCurrent={pagination.currentPage}
                            pageStop={pagination.numPages}
                            paginationPadding={pagination.windowPages}
                        />
                    </>
                )}
            </div>
            <div className="my-4">{t`All times displayed are in Japan Standard Time.`}</div>
            <ExportHistoryDataModal {...modalProps} />
        </FormProvider>
    );
};

export default SendingOrdersList;
